import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';
export function CoverHero() {
  return <section className="relative min-h-screen bg-solventum-dark flex items-center justify-center overflow-hidden" data-id="element-20">
      {/* Subtle animated background elements */}
      <motion.div className="absolute inset-0 opacity-30" animate={{
      backgroundPosition: ['0% 0%', '100% 100%']
    }} transition={{
      duration: 20,
      repeat: Infinity,
      repeatType: 'reverse'
    }} style={{
      backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(25, 165, 145, 0.35) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(28, 207, 147, 0.18) 0%, transparent 50%)',
      backgroundSize: '100% 100%'
    }} data-id="element-21" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-10 flex justify-center" data-id="element-23">
          <img src="https://cdn.magicpatterns.com/uploads/qHCwY7wts3zVy5vRBDiXqD/solventum-logo-vert-clr-rev-rgb.png" alt="Solventum" className="h-24 md:h-28 w-auto" data-id="element-24" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 rounded-full border border-solventum-green/40 bg-solventum-green/5 text-solventum-lightTeal text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-25">
          <PlayCircle className="w-3.5 h-3.5 text-solventum-green" data-id="element-26" />
          Clinical Masterclass Library
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-editorial text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-[1.05] tracking-tight" data-id="element-27">
          The Solventum
          <br className="hidden md:block" data-id="element-28" /> Clinical Masterclass
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-xl md:text-2xl text-solventum-lightTeal/80 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-29">
          A premium case-based learning library — real clinicians walking
          practitioners through real restorative cases, step by step.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex items-center justify-center gap-8 text-sm text-solventum-lightTeal/60" data-id="element-30">
          <span className="border-l-2 border-solventum-green pl-4" data-id="element-31">
            Prepared for Solventum
          </span>
          <span data-id="element-32">
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            year: 'numeric'
          })}
          </span>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      opacity: {
        delay: 1
      },
      y: {
        duration: 2,
        repeat: Infinity
      }
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2" data-id="element-33">
        <div className="w-6 h-10 border-2 border-solventum-lightTeal/30 rounded-full flex items-start justify-center p-2" data-id="element-34">
          <div className="w-1 h-2 bg-solventum-lightTeal/40 rounded-full" data-id="element-35" />
        </div>
      </motion.div>
    </section>;
}